import * as React from 'react';

const DeleteSvg = (props: any) => (
  <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx="13" cy="13" r="12" fill="white" stroke="currentColor" stroke-width="1.3" />
    <path
      d="M8.99992 17.6667C8.99992 18.4 9.59992 19 10.3333 19H15.6666C16.3999 19 16.9999 18.4 16.9999 17.6667V9.66667H8.99992V17.6667ZM10.3333 11H15.6666V17.6667H10.3333V11ZM15.3333 7.66667L14.6666 7H11.3333L10.6666 7.66667H8.33325V9H17.6666V7.66667H15.3333Z"
      fill="currentColor"
    />
  </svg>
);

export default DeleteSvg;
